function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';
import Svg, { Path } from 'react-native-svg';
export function Edit({
  width = 24,
  height = 24,
  ...props
}) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    width: width,
    height: width,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement(Path, {
    d: "M13.747 20.41H21",
    stroke: "#130F26",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement(Path, {
    clipRule: "evenodd",
    d: "M12.78 3.838a2.252 2.252 0 013.116-.302l1.733 1.341a2.127 2.127 0 01.72 2.97c-.034.055-9.537 11.89-9.537 11.89a1.702 1.702 0 01-1.31.63l-3.638.045-.82-3.455c-.115-.486 0-.996.316-1.389l9.42-11.73z",
    stroke: "#130F26",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement(Path, {
    d: "M11.02 6.035l5.453 4.169",
    stroke: "#130F26",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}
//# sourceMappingURL=Edit.js.map